module.exports = __webpack_public_path__ + "static/Elements-4742af1c77345fdf06502bc34034f14c.svg";